import { SectionMessage } from '@billy/design-system'
import type { SectionMessageProps } from '@billy/design-system'
import { PropsWithChildren, ReactElement } from 'react'

import * as Styled from './styles'

export type MessageBannerVariant = Exclude<SectionMessageProps['variant'], 'neutral' | undefined>

export interface MessageBannerProps extends PropsWithChildren {
  variant?: MessageBannerVariant
}

export const MessageBanner = ({ children, variant = 'warning' }: MessageBannerProps): ReactElement => {
  return (
    <Styled.MessageBannerWrapper>
      <SectionMessage variant={variant}>{children}</SectionMessage>
    </Styled.MessageBannerWrapper>
  )
}
